import {
  Directive,
  EventEmitter,
  Host,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { asapScheduler, Subscription } from 'rxjs';

@Directive({
  selector: '[appDeferRendering]',
})
export class DeferRenderingDirective implements OnDestroy {
  @Output()
  readonly onRendered = new EventEmitter<any>();

  private rendered = false;

  @Input()
  set appDeferRendering(value: boolean) {
    if (value && !this.rendered) {
      this.rendered = true;
      this.render();
    }
  }

  private _renderedSubscription: Subscription;

  constructor(
    @Host() private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnDestroy(): void {
    this._renderedSubscription?.unsubscribe();
  }

  private render() {
    this.viewContainerRef.createEmbeddedView(this.templateRef);

    const { onRendered } = this;
    this._renderedSubscription = asapScheduler.schedule(function () {
      onRendered.emit();

      this.unsubscribe();
    });
  }
}
